var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Gutenberg',{staticClass:"spacer--padding--x--m",attrs:{"data":_vm.post.gds_blocks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }